import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * shadcn/ui (AD #39): joins class names and lets a later Tailwind utility override an earlier
 * conflicting one — the `cn` helper every shadcn component composes its classes with.
 */
export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}
